import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  align-items: center;
  min-height: 100vh;
  display: flex;
  padding: 40px 0;
  flex-direction: column;
  align-items: center;

  p {
    text-align: center;
  }

  h1 {
    text-align: center;
    margin-bottom: 15px;
    color: #f2760a;
  }

  a {
    text-align: center;
    margin: 25px 0;
    font-size: 14px;
    color: #f2760a;
    text-decoration: underline;
  }

  @media (max-width: 750px) {
    padding: 30px 0;
    width: 95%;
    h1 {
      text-align: center;
      font-size: 22px;
      margin-bottom: 5px;
    }
  }
`;

export const Services = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  div {
    display: flex;
    padding: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: row;
    border-bottom: 2px solid #f2760a;
    button {
      display: flex;
      height: 20px;
      padding: 0 10px;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      background-color: #f2760a;
      font-size: 10px;
      color: #fff;
      line-height: 30px;
    }
    div {
      display: flex;
      padding: 0;
      margin: 0;
      margin-right: 15px;
      flex-direction: row;
      border: none;

      align-items: center;
      button {
        display: flex;
        height: 30px;
        width: 30px;
        padding: 0;
        border-radius: 5px;
        align-items: center;
        justify-content: center;
        background-color: #f2760a;
        font-size: 25px;
        color: #fff;
        line-height: 30px;
      }
      span {
        margin: 0 10px;
      }
    }
    p {
      color: #000;
    }
  }

  @media (max-width: 850px) {
    width: 100%;
  }
`;
